import React from 'react';

export const DataTableEmptyForm = () => {
  return <div />;
};
